// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mu-menu{display:inline-block;position:relative;vertical-align:middle}.mu-menu-toggle-icon{transition:transform .3s cubic-bezier(.23,1,.32,1)}.mu-menu__open .mu-menu-toggle-icon{transform:rotate(180deg)}.mu-menu-activator{align-items:center;cursor:pointer;height:100%;position:relative}.mu-menu-activator input[readonly]{cursor:pointer}.mu-menu.is-disabled .mu-menu-activator{cursor:default;pointer-events:none}", ""]);
// Exports
module.exports = exports;
